import { useMediaQuery } from 'react-responsive';

export const useMedia = () => {
  const isDesktop = useMediaQuery({ minWidth: 1440 });
  const isNotepad = useMediaQuery({ minWidth: 1280 });
  const isTablet = useMediaQuery({ minWidth: 768 });

  return {
    isDesktop,
    isNotepad: !isDesktop && isNotepad,
    isTablet: !isDesktop && !isNotepad && isTablet,
    isMobile: !isDesktop && !isNotepad && !isTablet,
  };
};
